import { apiV3 } from './api';
import type { SearchRequest, SearchResponse, MatchDetailResponse, AssetDetailResponse, TagsApiResponse } from '@/types';

// ─── Search Service (v3 — Omni Search) ───────────────────────────────────────

export const searchService = {
  /**
   * POST /api/v3/search
   * Omni search — segments + transcript windows + visual moments in parallel.
   * Powers the search results panel.
   */
  search: (payload: SearchRequest): Promise<SearchResponse> => {
    console.log('[searchService.search] POST /api/v3/search', payload);
    return apiV3.post<SearchResponse>('/search', payload).then((r) => r.data);
  },

  /**
   * GET /api/v3/assets/{asset_id}/match-detail?query=
   * Returns chapters, matched clips, visual moments, and summary in the
   * context of the search query. Called on search result card click.
   */
  getMatchDetail: (
    assetId: string,
    query: string,
  ): Promise<MatchDetailResponse> => {
    console.log(
      `[searchService.getMatchDetail] GET /api/v3/assets/${assetId}/match-detail`,
      { query },
    );
    return apiV3
      .get<MatchDetailResponse>(`/assets/${assetId}/match-detail`, {
        params: { query },
      })
      .then((r) => r.data);
  },

  /**
   * GET /api/v3/assets/{asset_id}/detail
   * Full asset page — all CU data, full transcript, tag overrides, sections.
   * Called when navigating to a standalone asset page (no query context).
   */
  getAssetDetail: (assetId: string): Promise<AssetDetailResponse> => {
    console.log(
      `[searchService.getAssetDetail] GET /api/v3/assets/${assetId}/detail`,
    );
    return apiV3.get<AssetDetailResponse>(`/assets/${assetId}/detail`).then((r) => r.data);
  },

  /**
   * GET /api/v3/search/tags
   * Returns available search-mode tags (object, activity, scene, filename, …).
   */
  getTags: (): Promise<TagsApiResponse> => {
    console.log('[searchService.getTags] GET /api/v3/search/tags');
    return apiV3.get<TagsApiResponse>('/search/tags').then((r) => r.data);
  },
};
